/** Mirrors backend wo-operator-scope: only manufacturing.wo.operate, no other manufacturing.* code. */
export const WO_OPERATE_PERMISSION = 'manufacturing.wo.operate';

export function isWoOperatorScope(user: {
  is_super_admin?: boolean | null;
  permissions?: string[] | null;
} | null | undefined): boolean {
  if (!user || user.is_super_admin) return false;
  const perms = user.permissions ?? [];
  if (!perms.includes(WO_OPERATE_PERMISSION)) return false;
  return !perms.some((code) => code.startsWith('manufacturing.') && code !== WO_OPERATE_PERMISSION);
}
